import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
import { DeleteRevisionAction } from '~src/revisionHistory/services/DeleteRevisionAction';
import { RevisionActions } from '~src/revisionHistory/services/RevisionActions';
import { UpdateRevisionNotesAction } from '~src/revisionHistory/services/UpdateRevisionNotesAction';
import { IDatasourceRevision } from '~src/revisionHistoryDatasource/serverApi/types/IDatasourceRevision';


export namespace RevisionActionDatasource {
  export function getDatasourceRevisionActionButtons(): RevisionHistoryActionButton<IDatasourceRevision>[] {
    const actions = [
      deleteDataSourceRevisionAction(),
      RevisionActions.downloadContentRevisionAction()
    ];
    if (FeatureFlags.enablePublishRevisionNotes) {
      actions.push(updateDatasourceRevisionNotesAction());
    }
    return actions;
  }

  // action button factories
  function deleteDataSourceRevisionAction(): RevisionHistoryActionButton<IDatasourceRevision> {
    return {
      name: 'delete',
      translate: 'delete_action',
      execute: (context: RevisionHistoryActionContext<IDatasourceRevision>) => {
        DeleteRevisionAction.showDeleteDataSourceRevisionDialog(context.selectedItem, context);
      }
    };
  }

  function updateDatasourceRevisionNotesAction(): RevisionHistoryActionButton<IDatasourceRevision> {
    return {
      name: 'updateNotes',
      translate: 'revisionNotesDialogTitle',
      execute: (context: RevisionHistoryActionContext<IDatasourceRevision>) => {
        UpdateRevisionNotesAction.showUpdateDatasourceRevisionNotesDialog(context.selectedItem, context);
      }
    };
  }
}
